export const MaterialJdeCodeConstant = {
    materialJde: 'api/MaterialJde'
};